import React from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import StoreBooking from '../Booking/storebooking';
import StoreHome from '../Home/storehome';
import Contact from '../contact';
import ProtectedRoute from '../protectedroute';
import Privacy, {Terms} from '../privacy';
import LoginRoute from '../loginroute';
import PackageList from '../Packages/packagelist';
import StoreProfile from '../Profile/storeprofile';
import StoreOrdersPage from "../Orders/storeorderspage";
import ScrollToTop from  "../scrolltop";
import NotFoundPage from "../notfoundpage";

const StoreRoutes = () => (
    <Router>
        <ScrollToTop>
        <Switch>
            <ProtectedRoute path="/" exact={true}  component={StoreBooking}/>
            <LoginRoute path="/login" component={StoreHome}/>
            <ProtectedRoute path="/orders"  component={StoreOrdersPage}/>
            <ProtectedRoute path="/profile"  component={StoreProfile}/>
            <ProtectedRoute path="/packages"  component={PackageList}/>
            <Route path="/contact-us" component={Contact} />
            <Route path="/privacy-policy" component={Privacy} />
            <Route path="/terms-and-conditions" component={Terms} />
            <Route component={NotFoundPage} />
        </Switch>
        </ScrollToTop>
    </Router>
)

export default StoreRoutes